module.exports = __webpack_public_path__ + "img/com.codeway.scannerplus.dcaf0d07.png";